/**
 *	app.js
 */

import 'mahnunchik/markerclustererplus';
import angular from 'angular';
import 'angular-ui-router';
import 'angular-messages';

import appTpl from './app.tpl.html!text';

import appConf from './app.conf.js';

import store from './store/store.serv.js';

/**
 *  Components.
 */

import breadcrumbs from './components/breadcrumbs/breadcrumbs.conf.js';
import cityDistrictSelect from './components/city-district-select/city-district-select.conf.js';
import createAppointment from './components/create-appointment/create-appointment.conf.js';
import galleryCarousel from './components/gallery-carousel/gallery-carousel.conf.js';
import map from './components/map/map.conf.js';
import modal from './components/modal/modal.conf.js';
import nearbyShops from './components/nearby-shops/nearby-shops.conf.js';
import offer from './components/offer/offer.component.js';
import searchBox from './components/search-box/search-box.conf.js';
import searchBoxTitle from './components/search-box-title/search-box-title.component.js';
import shopHighlights from './components/shop-highlights/shop-highlights.component.js';
import shopInfo from './components/shop-info/shop-info.conf.js';
import shopList from './components/shop-list/shop-list.conf.js';
import shopListTitle from './components/shop-list-title/shop-list-title.conf.js';
import shopSchedule from './components/shop-schedule/shop-schedule.conf.js';
import shopServices from './components/shop-services/shop-services.conf.js';

/**
 *  Directives.
 */

import bodyPaddingRemover from './directives/body-padding-remover/body-padding-remover.directive.js';
import removeClassDirective from './directives/remove-class/remove-class.directive.js';
import shopTooltip from './directives/shop-tooltip/shop-tooltip.directive.js';

/**
 *  Services.
 */

import AjaxCancellerServ from './services/ajax-canceller.serv.js';
import ApiServ from './services/api.serv.js';
import HelperServ from './services/helper.serv.js';
import ShopDetailsServ from './services/shop-details.serv.js';
import ShopTypesServ from './services/shop-types.serv.js';
import AssetsServ from './services/assets.serv.js';

/**
 *  States.
 */

import home from './states/home/home.conf.js';
import orangeMoneyShops from './states/orange-money-shops/orange-money-shops.conf.js';
import errorConf from './states/error/error.conf.js';
import shopDetailsConf from './states/shop-details/shop-details.conf.js';
import shopsByCityOrDistrict from './states/shops-by-city-or-district/shops-by-city-or-district.conf.js';

import AppCtrl from './app.ctrl.js';
import ErrorCtrl from './states/error/error.ctrl.js';
import ShopDetailsCtrl from './states/shop-details/shop-details.ctrl.js';

angular.module('app', [
    'ui.router',
    'ngMessages',
    store,
    // States.
    home,
    orangeMoneyShops,
    // Components
    breadcrumbs,
    cityDistrictSelect,
    createAppointment,
    shopList,
    galleryCarousel,
    map,
    modal,
    nearbyShops,
    offer,
    searchBox,
    searchBoxTitle,
    shopHighlights,
    shopInfo,
    shopsByCityOrDistrict,
    shopListTitle,
    shopSchedule,
    shopServices,
    // Directives
    shopTooltip,
    bodyPaddingRemover
])
.config(appConf)
.config(errorConf)
.config(shopDetailsConf)
.controller('AppCtrl', AppCtrl)
.controller('ErrorCtrl', ErrorCtrl)
.controller('ShopDetailsCtrl', ShopDetailsCtrl)
.directive('removeClass', removeClassDirective)
.service('ajaxCancellerServ', AjaxCancellerServ)
.service('apiServ', ApiServ)
.service('helperServ', HelperServ)
.service('shopDetailsServ', ShopDetailsServ)
.service('shopTypesServ', ShopTypesServ)
.service('assetsServ', AssetsServ);

const appDiv = document.getElementById("shop-locator-app");
if (appDiv) {
    angular.element(document).ready(function() {
        appDiv.innerHTML = appTpl;
        angular.bootstrap(angular.element(appDiv), ['app']);
    });
}
